import React from 'react'

import { Form, Col } from '_zari/core'

import { SelectMesContabilidad } from 'sharedComponents/select'

const MesFormGroup = ({ texto, periodo, setPeriodo }) => {
  return (
    <Form.Group>
      <Form.Label text={texto} md={2} alignRightAt='md' />
      <Col md={10}>
        <SelectMesContabilidad mesFin={15} id={`select-mesContabilidad-${texto}`} value={periodo} onChange={setPeriodo} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(MesFormGroup)
